import { REVEAL_PHONE_BAR_EVENT } from '@/shell/phoneBarReveal';

/**
 * Puts the caret in the shell's search field (the ⌘F command). Found by its `data-global-search`
 * mark, not its accessible name: the name is in the reader's language (I-1971).
 */
export function focusGlobalSearch(): void {
  document.querySelector<HTMLInputElement>('input[data-global-search]')?.focus();
}

/** What the bar at the top listens for to open its results with the caret in it (⌘K, VSB-34). */
export const OPEN_SEARCH_BAR_EVENT = 'featit:open-search-bar';

/**
 * ⌘K (F-0743 §4, VSB-34, VSB-35e): the caret goes into the bar and its results open; no modal
 * palette. On a phone the bar first comes down from under the top row, as a pull brings it.
 * `false` where the screen draws no bar (a phone's pushed screen), where ⌘K is the palette.
 */
export function openSearchBar(): boolean {
  const bar = document.querySelector<HTMLInputElement>(
    'input[data-global-search][data-search-bar]',
  );
  if (!bar) return false;
  bar.dispatchEvent(new Event(REVEAL_PHONE_BAR_EVENT, { bubbles: true }));
  bar.focus();
  bar.dispatchEvent(new Event(OPEN_SEARCH_BAR_EVENT));
  return true;
}
